module.exports = __webpack_public_path__ + "static/media/myradio.6b67b35d.svg";